import { useOutletContext } from "react-router-dom";
import { useConfiguracionTiendaPublic } from "../store/hooks/useConfiguracionTiendaPublic";
import "./AccountOrders.css";

const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";

  return d.toLocaleDateString("es-GT", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

const getPagoBadge = (estadoPago) => {
  const value = String(estadoPago || "").toUpperCase();

  if (value === "PAGADO") {
    return { text: "Pagado", className: "is-paid" };
  }

  if (value === "AUTORIZADO") {
    return { text: "Autorizado", className: "is-paid" };
  }

  if (value === "PENDIENTE") {
    return { text: "Pago pendiente", className: "is-unpaid" };
  }

  if (value === "FALLIDO") {
    return { text: "Pago fallido", className: "is-cancelled" };
  }

  if (value === "REEMBOLSADO") {
    return { text: "Reembolsado", className: "is-unknown" };
  }

  return { text: "Sin registro de pago", className: "is-unpaid" };
};

export default function AccountOrders({ embedded }) {
  const {
    orders,
    loadingOrders,
    openOrderDetails,
    openOrderDocs,
  } = useOutletContext();

  const { formatMoney } = useConfiguracionTiendaPublic();
  const pageOrders = Array.isArray(orders) ? orders : [];

  return (
    <div className={`adc-orders${embedded ? " is-embedded" : ""}`}>
      {!embedded ? (
        <div className="adc-orders-head">
          <div>
            <h2 className="adc-orders-title">Pedidos</h2>
            <p className="adc-orders-sub">
              Consulta el estado de tus compras y abre los detalles de cada pedido.
            </p>
          </div>
        </div>
      ) : null}

      {loadingOrders ? (
        <p className="adc-orders-sub">Cargando pedidos…</p>
      ) : pageOrders.length === 0 ? (
        <p className="adc-orders-sub">No tienes pedidos registrados.</p>
      ) : (
        <div className="adc-orders-list">
          {pageOrders.map((o) => {
            const estadoPedido = o?.estado_pedido || "—";
            const estadoPago = o?.estado_pago || null;
            const metodoEnvio = o?.metodo_envio || null;
            const zonaEnvio = o?.zona_envio || null;
            const total = o?.total_factura ?? 0;
            const fecha = o?.fecha_creado || null;

            const pagoBadge = getPagoBadge(estadoPago);

            return (
              <article key={o.pedido_id} className="adc-order-item">
                <div className="adc-order-main">
                  <div className="adc-order-top">
                    <div className="adc-order-id">
                      Pedido <span>#{o.pedido_id}</span>
                    </div>
                    <div className="adc-order-date">{formatDate(fecha)}</div>
                  </div>

                  <div className="adc-order-meta">
                    <span className="adc-badge">{estadoPedido}</span>

                    <span className={`adc-badge ${pagoBadge.className}`}>
                      {pagoBadge.text}
                    </span>

                    {metodoEnvio ? (
                      <span className="adc-badge is-ship">
                        Envío: {metodoEnvio}
                      </span>
                    ) : null}

                    {zonaEnvio ? (
                      <span className="adc-badge is-ship">
                        Zona: {zonaEnvio}
                      </span>
                    ) : null}
                  </div>

                  <div className="adc-order-bottom">
                    <div className="adc-order-total">
                      Total: <strong>{formatMoney(total)}</strong>
                    </div>
                  </div>
                </div>

                <div className="adc-order-actions">
                  <button
                    type="button"
                    className="adc-btn adc-btn-secondary"
                    onClick={() => openOrderDetails(o.pedido_id)}
                  >
                    Ver detalles
                  </button>

                  <button
                    type="button"
                    className="adc-btn adc-btn-primary"
                    onClick={() => openOrderDocs(o.pedido_id)}
                    title="Ver documentos del pedido"
                  >
                    Ver archivos
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
